export default __webpack_public_path__ + "static/media/ronin-colored.4d56a986.webp";